// extracted by css-extract-rspack-plugin
export default {"root":"root-HQ93iD"};